import type { RouteRecordRaw } from 'vue-router';
import { INVITE_MANY_EMPLOYEES_WIZARD_NAMESPACE } from '../pages/InvitationFlow/invite-many-employees-wizard';
import { MASSIVE_EMPLOYEE_DEACTIVATION_WIZARD_NAMESPACE } from '../pages/MassiveDeactivationFlow/massive-employee-deactivation-wizard';
import {
  employeeRoutesDictionary,
  subscriptionRoutesDictionary,
} from './employee-routes.dictionary';

export const employeeRoutesConfig: RouteRecordRaw = {
  ...employeeRoutesDictionary.employees.root,
  redirect: { name: employeeRoutesDictionary.employees.list.name },
  children: [
    {
      ...employeeRoutesDictionary.employees.list,
      component: () => import('../pages/List/EmployeeListPage.vue'),
    },
    {
      ...employeeRoutesDictionary.employees.create,
      component: () =>
        import('../pages/Create/CreateEmployeePage/CreateEmployeePage.vue'),
    },
    {
      ...employeeRoutesDictionary.employees.detail,
      component: () =>
        import('../pages/List/Detail/EmployeeDetailTabsRoot.vue'),
      props: true,
    },
    {
      ...employeeRoutesDictionary.employees.creditsDetail,
      component: () =>
        import(
          '../pages/List/Detail/Tabs/CreditsSection/Detail/EmployeeCreditsSectionDetailPage.vue'
        ),
      props: true,
    },
    {
      ...employeeRoutesDictionary.employees.editAnagraphic,
      component: () =>
        import('../pages/EditAnagraphicData/EditAnagraphicData.vue'),
      props: true,
    },
    {
      ...employeeRoutesDictionary.employees.editCompany,
      component: () => import('../pages/EditCompanyData/EditCompanyData.vue'),
      props: true,
    },
    {
      ...employeeRoutesDictionary.employees.inviteMany,
      meta: {
        wizardNamespace: INVITE_MANY_EMPLOYEES_WIZARD_NAMESPACE,
        wizardExitRoute: employeeRoutesDictionary.employees.list.name,
      },
      component: () =>
        import('../pages/InvitationFlow/InviteManyEmployeesWizardPage.vue'),
    },
    {
      ...employeeRoutesDictionary.employees.massiveEmployeeDeactivation,
      meta: {
        wizardNamespace: MASSIVE_EMPLOYEE_DEACTIVATION_WIZARD_NAMESPACE,
        wizardExitRoute: subscriptionRoutesDictionary.subscriptions.list.name,
      },
      component: () =>
        import(
          '../pages/MassiveDeactivationFlow/MassiveEmployeeDeactivationWizardPage.vue'
        ),
    },
  ],
};

export const subscriptionRoutesConfig: RouteRecordRaw = {
  ...subscriptionRoutesDictionary.subscriptions.root,
  redirect: { name: subscriptionRoutesDictionary.subscriptions.list.name },
  children: [
    {
      ...subscriptionRoutesDictionary.subscriptions.list,
      component: () =>
        import('../pages/Subscriptions/SubscriptionListPage.vue'),
    },
    {
      ...subscriptionRoutesDictionary.subscriptions.deactivated,
      component: () =>
        import(
          '../pages/Subscriptions/Deactivated/DeactivatedSubscriptionListPage.vue'
        ),
    },
  ],
};
